<div class="chart enable-graph-container">
  <span id="CLO-enableFeature-text" class="enable-graph-label">Enable feature</span><input type="checkbox" [checked]="enableChecked"
  class="primary-checkbox" id="EnableGraph" (change)="enableGraph($event.target.checked)" />
  <label for="EnableGraph" aria-label="Enable feature"><span id="CLO-enableFeature-checkbox" class="extra-border-enablefeat"></span></label>
</div>
<div class="row clo-table-container blockCss">
  <div class="col-2">
    <div id="CLO-schedule-text" class="schedule" [ngClass]="{ 'schedule-disabled': disableGraph }">Schedule</div>
  </div>
  <div class="col-7">
    <div class="chart container" [ngClass]="disableGraph ? 'disable-graph' : 'enable-graph'">

      <ul ngbNav #nav="ngbNav" [activeId]="activeIdString" (navChange)="tabChanged($event)" class="nav-tabs">
        <li ngbNavItem="1" [ngClass]="disableGraph ? 'nav-item nav-link' : 'nav-item active'">
          <a ngbNavLink><span id="CLO-numericGenerator-tab">Numeric generator</span></a>
          <ng-template ngbNavContent [formGroup]="addForm">
            <button
              style="margin-left: 19em;"
              id="CLO-numericGenerator-clearFields"
              type="button"
              class="numeric-clear"
              [disabled]="disableNumericClear"
              (click)="clearNumericFields('default', true)"
              [ngClass]="{'disable-numeric-clear': disableNumericClear===true}">
              Clear fields
            </button>
            <form id="CLO-numericGenerator-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>
              <div class="row chart-rows">
                <div id="CLO-activeHours-text" class="col-5">CLO active hours</div>
                <div class="col-7 form-group">
                  <input id="CLO-activeHours-input" type="text"  appOnlynumber class="form-control" formControlName="cloHour" maxlength="6" size="4"
                    [ngClass]="{ 'is-invalid': submitted && f.cloHour.errors, 'initial-input': afterClearField===true }"
                    (keyup)="inputValueChanged($event)" /><span id="CLO-activeHours-suffix" class="field-suffix"> x 1000 h</span>
                  </div>
                </div>
                <div class="row chart-rows">
                  <div id="CLO-steps-text" class="col-5">Number of steps</div>
                  <div class="col-7 form-group">
                    <input id="CLO-steps-input" type="text" class="form-control" formControlName="cloSteps" maxlength="3"
                      size="4"
                      appOnlynumber
                      [ngClass]="{ 'is-invalid': submitted && f.cloSteps.errors, 'initial-input': afterClearField===true }"
                      (keyup)="inputValueChanged($event)" />
                    </div>
                  </div>
                  <div class="row chart-rows">
                    <div id="CLO-initialOutput-text" class="col-5">Initial output level</div>
                    <div class="col-7 form-group">
                      <input id="CLO-initialOutput-input" type="text" class="form-control" formControlName="initialOutput" maxlength="3"
                        size="4"
                        appOnlynumber
                        [ngClass]="{ 'is-invalid': submitted && f.initialOutput.errors, 'initial-input': afterClearField===true }"
                        (keyup)="inputValueChanged($event)" /><span id="CLO-initialOutput-suffix" class="field-suffix"> %</span>
                      </div>
                    </div>
                    <div class="row chart-rows">
                      <div id="CLO-finalOutput-text" class="col-5">Final output level</div>
                      <div class="col-7 form-group">
                        <input id="CLO-finalOutput-input" type="text" class="form-control" formControlName="finalOutput" maxlength="3"
                          size="4"
                          appOnlynumber
                          [ngClass]="{ 'is-invalid': submitted && f.finalOutput.errors, 'initial-input': afterClearField===true }"
                          (keyup)="inputValueChanged($event)" /><span id="CLO-finalOutput-suffix" class="field-suffix"> %</span>
                        </div>
                      </div>
                    </form>
                  </ng-template>
                </li>
                <li ngbNavItem="2" [ngStyle]="{'width':'78px !important'}">
                  <a ngbNavLink><span id="CLO-tableValues-tab">Table values</span></a>
                  <ng-template ngbNavContent class="">
                    <div id="CLO-tableValues-section" class="table-values" [formGroup]="addForm">
                      <div class="table-values-fields">
                        <div id="CLO-workingHours-text">Working hours<div>x 1000 h</div>
                      </div>
                      <div id="CLO-outputLevel-text">Output level<div>%</div>
                    </div>
                    <button id="CLO-table-clearFields"
                      type="button"
                      class="table-clear"
                      (click)="clearTableValueFields()">
                      Clear fields
                    </button>
                  </div>
                  <table>
                    <caption class="dn">CLO</caption>
                    <thead class="dn">
                      <tr>
                        <th scope="col">Working Hours</th>
                        <th scope="col">Output Level</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of addForm.get('rows')?.controls; track row; let index = $index) {
                        <tr
                          (contextmenu)="onRightClick($event, index); false">
                          <td><input id="CLO-tableInput-workingHours-{{index}}" class="form-control" [formControl]="row.get('workingHours')"
                            appOnlynumber
                            maxlength="6" size="6"
                            [ngClass]="{ 'is-invalid': tableValueSubmit && row.get('workingHours').errors }" />
                          </td>
                          <td><input id="CLO-tableInput-outputLevel-{{index}}" class="form-control" [formControl]="row.get('outputLevel')"
                            appOnlynumber
                            maxlength="6" size="6"
                            [ngClass]="{ 'is-invalid': tableValueSubmit && row.get('outputLevel').errors }" />
                          </td>
                          @if (rowLength!=1) {
                            <td>
                              <button id="CLO-table-deleteRow-{{index}}"
                                type="button"
                                class="delete-row"
                                (click)="RemoveRow(index)">
                                &times;
                              </button>
                            </td>
                          }
                        </tr>
                      }
                      <tr>
                        <td></td>
                        <td></td>
                        <td colspan="3">
                          <button id="CLO-table-addRow" class="add-row" (click)="AddRow()" [disabled]="disableAddBtn"
                          [ngClass]="{'disable-graph': disableAddBtn===true}">+</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-template>
            </li>
          </ul>
          <div id="CLO-tab-content" [ngbNavOutlet]="nav"></div>
        </div>
      </div>
    </div>
    <br>

      <nav #contextMenu [ngClass]="menuState?'context-active':'context-menu'"
        [ngStyle]="{'left':menuPositionX, 'top':menuPositionY}">
        <div class="add-row-menu"><button [disabled]="disableAddAboveBtn" (click)="addRowAbove()">&#9650; Add row
        above</button></div>
        <div class="add-row-menu"><button [disabled]="disableAddBelowBtn" (click)="addRowBelow()">&#9660; Add row
        below</button></div>
      </nav>
